import { NgOptimizedImage } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderConfigService } from '../../services/header-config.service';

@Component({
    selector: 'app-redirection-screen',
    standalone: true,
    templateUrl: './redirection-screen.component.html',
    styleUrl: './redirection-screen.component.scss',
    imports: [NgOptimizedImage],
})
export class RedirectionScreenComponent implements OnInit {
    public time = 3;

    constructor(
        private headerConfigService: HeaderConfigService,
        private router: Router
    ) {
        this.headerConfigService.setVisibility(false);
    }

    ngOnInit(): void {
        const interval = setInterval(() => {
            this.time--;
            if (!this.time) {
                clearInterval(interval);
                this.headerConfigService.setVisibility(true);
                this.router.navigate(['/search-awb']);
            }
        }, 1000);
    }
}
